import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext({
  darkMode: false,
  toggleDarkMode: () => {}, // Define a default function for better context usage
});

export const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(false);

  // 1. Check for saved theme preference or use system preference
  useEffect(() => {
    // Check local storage first
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme !== null) {
      setDarkMode(JSON.parse(savedTheme));
    } else {
      // Fallback to system preference
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      setDarkMode(prefersDark);
    }
  }, []);

  // 2. CRUCIAL: Update HTML element class and localStorage when theme changes
  // This replaces all your manual style updates and uses the 'dark' class
  // which is required by Tailwind CSS.
  useEffect(() => {
    const html = document.documentElement; // Target the <html> element

    // Step 1: Manage the 'dark' class for Tailwind
    if (darkMode) {
      // Use 'dark' class name, not 'dark-mode'
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
    }
    
    // Step 2: Clean up old body styles/classes (optional, but good practice)
    document.body.classList.remove('dark-mode');
    document.body.style.backgroundColor = '';
    document.body.style.color = '';

    // Step 3: Persist preference
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(prevMode => !prevMode);
  };

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;